import React from 'react';
import {withRouter, Link} from 'react-router';
import PropTypes from 'prop-types';
import {resource} from '@albert-io/json-api-framework/request/builder';
import {TooltipWrapper} from 'sg/Tooltip/Tooltip.react';
import {Button} from '@albert-io/atomic';
import {RANGES} from '@albert-io/atomic/organisms/DatePicker/DatePicker.helpers';

import classroomInsightsStore from '../../../ClassroomInsights.store';

class StandardsTable extends React.Component {
  static propTypes = {
    params: PropTypes.shape({
      questionId: PropTypes.string,
      classId: PropTypes.string
    })
  };

  getStandardsQuery() {
    return resource('labels_v1').mandarkEndpoint([
      'questions_v2',
      this.props.params.questionId,
      'labels_v1'
    ]);
  }

  renderCategory(standard) {
    return standard.getCategory() || 'N/A';
  }

  renderName(standard) {
    return <TooltipWrapper tooltip={standard.getText()}>{standard.getName()}</TooltipWrapper>;
  }

  renderStandardButton = (standard) => {
    const subject = classroomInsightsStore.getSubject();
    return (
      <Button
        whiteBg
        small
        onClick={(e) => e.stopPropagation()}
        as={Link}
        to={`/${subject.getUrlSlug()}?standards=${standard.getId()}`}
      >
        Find questions
      </Button>
    );
  };

  render() {
    const {classId} = this.props.params;
    const subjectId = classroomInsightsStore.getSubjectId();
    const attemptNumber = classroomInsightsStore.getAttemptNumber();
    const guideLevelId = classroomInsightsStore.getGuideLevelId();
    const [startDate] = new Date(classroomInsightsStore.getStartDate()).toISOString().split('T');
    const [endDate] = new Date(classroomInsightsStore.getEndDate()).toISOString().split('T');
    const reportsLink =
      `/reports/classrooms/${classId}/students?attempt=${attemptNumber}` +
      `&subject=${subjectId}&guideLevel=${guideLevelId}&range=${RANGES.CUSTOM}&start=${startDate}&end=${endDate}`;

    return (
      <div className='u-display_flex u-justify-content_center u-pad_4'>
        <div>
          <h3>This report has been deprecated.</h3>
          <p>You can access the same data via the new reports feature.</p>
          <Button color='green' as='a' href={reportsLink}>
            Open Reports
          </Button>
        </div>
      </div>
    );
  }
}

export default withRouter(StandardsTable);
